import React from "react";
import MuiSnackBar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { AlertColor } from "@mui/material";

export interface SnackbarProps {
    open: boolean;
    message: string;
    severity?: AlertColor;
    autoHideDuration?: number;
    onClose: () => void;
    anchorOrigin?: {
        vertical: "top" | "bottom";
        horizontal: "left" | "center" | "right";
    };
}

const Snackbar: React.FC<SnackbarProps> = ({
    open,
    message,
    severity = "success",
    autoHideDuration = 2500,
    onClose,
    anchorOrigin = { vertical: "top", horizontal: "center" },
}) => {
    return (
        <MuiSnackBar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                variant="filled"
                sx={{
                    fontWeight: 500,
                    ...(severity === "success" && {
                        backgroundColor: "var(--primary-color)",
                        color: "white",
                        border: "1px solid var(--primary-color)",
                        borderRadius: "40px",
                    }),
                }}
            >
                {message}
            </Alert>
        </MuiSnackBar>
    );
};

export default Snackbar;
